import React from 'react';

import { LoadablePaint } from '@confluence/loadable';
import { ADMIN_HOME_ID } from '@confluence/app-navigation/entry-points/navigationIDs.ts';
import { useSessionData } from '@confluence/session-data/entry-points/useSessionData.ts';
import type { ConfluenceEdition } from '@confluence/session-data/entry-points/SiteInformationQuery.ts';

const AdminCenterPage = LoadablePaint({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-confluenceadmin-center" */ '@confluence/admin-center'
			)
		).AdminCenterPage,
});

export const AdminCenterRoute: {
	(): React.JSX.Element;
	NAVIGATION_PARAMS(): {
		Screen: {
			screenEvent: {
				name: string;
				attributes: {
					edition: ConfluenceEdition | null;
				};
			};
		};
		MainLayout: {
			navView: string;
		};
	};
} = (): React.JSX.Element => <AdminCenterPage />;

AdminCenterRoute.NAVIGATION_PARAMS = (): {
	Screen: {
		screenEvent: {
			name: string;
			attributes: {
				edition: ConfluenceEdition | null;
			};
		};
	};
	MainLayout: {
		navView: string;
	};
} => {
	// eslint-disable-next-line react-hooks/rules-of-hooks
	const { edition } = useSessionData();
	return {
		Screen: {
			screenEvent: { name: 'adminCenter', attributes: { edition } },
		},
		MainLayout: {
			navView: ADMIN_HOME_ID,
		},
	};
};
